
import { Component, ViewChild, Inject, NgZone } from '@angular/core';
import { Platform, ModalController, AlertController, IonicPage, NavController, NavParams, ToastController, Content } from 'ionic-angular';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GlobalProvider } from '../../providers/global/global';
import { TimesheetType3Page } from '../timesheet-type3/timesheet-type3';
import { Camera } from '@ionic-native/camera';
import { ConfirmType1Page } from '../../pages/confirm-type1/confirm-type1';
import { RequestsProvider } from '../../providers/requests/requests';
import { PopoverController } from 'ionic-angular';
import { PopoverPage } from '../popover/popover';
import { ExpensePopUpPage } from '../expense-pop-up/expense-pop-up';
import { Keyboard } from 'ionic-angular';
import { DOCUMENT } from '@angular/common';
import { ConfirmType1MonthlyPage } from '../../pages/confirm-type1-monthly/confirm-type1-monthly';
// import { Keyboard } from '@ionic-native/keyboard';
// import * as fs from 'fs';

/**
 * Generated class for the ExpensesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-expenses',
  templateUrl: 'expenses.html',
})
export class ExpensesPage {
  
  expenses_data: any;
  expenses_ddl: any;
  GUID:string;

  body: string = "INSTRUCTIONS: To attach an image to this expense entry simply attach it to this mail and press send.%0D%0A %0D%0ANOTE: Do not alter the subject or to address.%0D%0A %0D%0AYour email must be sent from the email address that you login with. %0D%0A %0D%0APlease allow up to 5 minutes for your image to be received and processed, after which time your image will be visible on the expense form.%0D%0A %0D%0A";
  toEmailAddress: string = "expenses@thetimegenie.co.uk";
  xmlString: string = '';

  public base64Files: string[] = [];
  public base64FilesNames: string[] = [];
  private files: any[] = [];
  private fileReader = new FileReader();
  modal: any;
  // resize:boolean = true;
  imgsrc:string="";
  hidenextprev:boolean=true;
  ishidden:boolean=false;
  @ViewChild(Content) content: Content;
  
  expenses_taxhandling: number = 0;
  expenses_imageupload: number = 0;
  
  constructor(private modalCtrl: ModalController, public camera : Camera,public global: GlobalProvider,public requests:RequestsProvider,public http: HttpClient, public navCtrl: NavController,
    public navParams: NavParams,private toastCtrl: ToastController, private alertCtrl: AlertController,
    public popoverCtrl: PopoverController, public keyboard: Keyboard, public platform:Platform
    , @Inject(DOCUMENT) document
    , private zone: NgZone
  ) {

      
      // this.platform.registerBackButtonAction(()=>{alert("BACK CLICKED")},1);
      this.keyboard.onClose(this.closeCallback);
      this.expenses_data = JSON.parse(this.global.dt_expenses[1]); //original
      //console.log(this.expenses_data);
      for(var i = 0; i< this.expenses_data.length;i++){
        var amount = this.expenses_data[i].Amount;
        this.expenses_data[i].Amount = amount.toFixed(2);

        var pay = this.expenses_data[i].Payment;
        this.expenses_data[i].Payment = pay? pay: "P";

        if(!this.expenses_data[i].ExpenseTypeId)  this.expenses_data[i].ExpenseTypeId = 8;

        this.expenses_taxhandling = this.expenses_data[i].ExpenseTAXHandling;
        this.expenses_imageupload = this.expenses_data[i].ExpenseImageUpload;
      }
      console.log(this.expenses_data);
      //this.expenses_data_values = this.expenses_data; //contains any changes 
      this.expenses_ddl = JSON.parse(this.global.dt_expenses_ddl[0]);
      this.global.mileage_rate = this.expenses_data[0].Mileage;

  }
  
  
  
  closeCallback() {
    // alert("closed");
    // alert('Closing time');
  }
  presentPopover(myEvent) {
    let popover = this.popoverCtrl.create(PopoverPage);
    popover.present({
      ev: myEvent
    });
  }

  presentExpensePopupModal() {

    //get if there is an empty expense spot
    var indxEmptyExpense = this.expenses_data.findIndex(function(item, i){
      return item.ExpenseEntryId === 0
    });
    // if(!(indxEmptyExpense >= 0 )) {this.presentToast('You can only add up to 10 expenses!'); return;}
    if(!(indxEmptyExpense >= 0 )) {this.presentToast("You've reached max no of expenses."); return;}


    
    let profileModal = this.modalCtrl.create(ExpensePopUpPage, {
      expense_ddl: this.expenses_ddl
      , expense_data: this.expenses_data
      , expenses_taxhandling: this.expenses_taxhandling
      , expenses_imageupload: this.expenses_imageupload
    });
    profileModal.onDidDismiss(data => {
      if(!data) return;
      //this.content.resize();
      //profileModal._didEnter();
      //this.navCtrl._didEnter();
      this.expenses_data = data.expenses_data;
    });
    profileModal.present();
    
  }

  Grids_get(id: string)
  {
    // debugger
    if(this.requests.GridDataReceived.observers.length==0){
      this.requests.GridDataReceived.subscribe(
        () => {
          //console.log('Grid Data Received.......... : ' );
          
          this.global.tab2index = this.global.ndays - 1;
          this.navCtrl.push(TimesheetType3Page, {TAB2ID: this.global.TAB2id[this.global.tab2index]});
          
        }
      );
    }
    this.requests.httpRequestGrid1_read(id);
  }
  

  // uploadReceipt(event: Event, i :string) {
  //   //debugger
    
  //   let files = event.target['files'];
  //   this.GUID = this.expenses_data[i].GUID;
    
  //   if (event.target['files']) {
  //     // console.log(event.target['files']);
  //     this.readFiles(event.target['files'], 0);
  //     // console.log(this.base64Files);
  //     // console.log(this.base64Files.length);
  //   }
  // };

  // readFiles(files: any[], index: number) {
  //   let file = files[index];
  //   this.fileReader.onload = () => {
  //     // debugger
  //     // console.log(this.fileReader.result);
  //     var img = document.createElement("img");

  //     // if(this.resize){
  //     // debugger
  //     img.src = this.fileReader.result.toString();
  //     img.onload = () => {
  //       var canvas = document.createElement("canvas");
  //       //var canvas = $("<canvas>", {"id":"testing"})[0];
  //       var ctx = canvas.getContext("2d");
  //       ctx.drawImage(img, 0, 0);

  //       var MAX_WIDTH = 400;
  //       var MAX_HEIGHT = 400;
  //       var width = img.width;
  //       var height = img.height;

  //       if (width > height) {
  //         if (width > MAX_WIDTH) {
  //           height *= MAX_WIDTH / width;
  //           width = MAX_WIDTH;
  //         }
  //       } else {
  //         if (height > MAX_HEIGHT) {
  //           width *= MAX_HEIGHT / height;
  //           height = MAX_HEIGHT;
  //         }
  //       }
  //       canvas.width = width;
  //       canvas.height = height;
  //       var ctx = canvas.getContext("2d");
  //       ctx.drawImage(img, 0, 0, width, height);
        
  //       // debugger
        
  //       var dataurl = canvas.toDataURL("image/png");
        
  //       this.base64FilesNames.push(file.name);
  //       this.base64Files.push(dataurl);
  //       if (files[index + 1]) {
  //         this.readFiles(files, index + 1);
  //       } else {
  //         //console.log('loaded all files');
  //         this.uploadReceipt_toServer();
  //       }
  //     }
  //     // document.getElementById('image').src = dataurl;  
  //     // } else { 

  //     //   this.base64FilesNames.push(file.name);
  //     //   this.base64Files.push(this.fileReader.result.toString());
        
  //     //   if (files[index + 1]) {
  //     //     this.readFiles(files, index + 1);
  //     //   } else {
  //     //     console.log('loaded all files');
  //     //     this.uploadReceipt_toServer();
  //     //   }
  //     // }
      
  //   };
  //   this.fileReader.readAsDataURL(file);
  // }


  // uploadReceipt_toServer() {

  //   var p: any = {};
  //   p.body = this.body;
  //   p.GUID = this.GUID;
  //   p.subject = this.GUID;
  //   p.ToEmailAddress = this.toEmailAddress;
  //   p.UserName = localStorage.getItem('username');
  //   p.attachments = this.base64Files;
  //   p.attchementsNames = this.base64FilesNames;

  //   const params = new HttpParams()
  //   .set('j', JSON.stringify(p))

  //   this.global.createLoader();
  //   this.global.loading.present().then((result) => {
  //     this.http.post('timesheets/upload_expenses/', params ).subscribe(

  //       (data) => {
  //         this.global.loading.dismiss();
  //         this.presentToast('Image uploaded successfully.');
  //         if(this.requests.ExpensesDataReceived.observers.length==0){
  //           this.requests.ExpensesDataReceived.subscribe(
  //             () => {
  //               //console.log('Expenses Data Received.......... : ' );
  //               this.expenses_data = JSON.parse(this.global.dt_expenses[1]); 
  //               for (var i=0; i< this.expenses_data.length;i++){
  //                 // debugger
  //                 var amount = this.expenses_data[i].Amount;
  //                 this.expenses_data[i].Amount = amount.toFixed(2);
  //               }
  //               //this.global.tab2index = this.global.ndays - 1;
  //               //this.navCtrl.push(TimesheetType3Page, {TAB2ID: this.global.TAB2id[this.global.tab2index]});
  //             }
  //           );
  //         }
  //         this.requests.httpRequestExpenses_read();
          
          
  //         this.base64Files=[];
  //         this.base64FilesNames=[];
          
  //       },
  //       error => {
  //         alert(error);
  //       }
  //     );
  //   }).catch((err) => {

  //   });

  // }

  uploadReceipt( event: Event, i :string ) {
    
    let files = event.target['files'];
    if(!files.length) return;

    const maxAllowedSize = 5 * 1024 * 1024; //5MB
    if (files[0].size > maxAllowedSize) {
      alert('File size is very big. Please limit to 5MB.');
      return;
    }

    this.GUID = this.expenses_data[i].GUID;
    let formData = new FormData();
    formData.append('files[]', files[0], files[0].name);

    formData.append('body' , this.body);
    formData.append('GUID' , this.GUID);
    formData.append('subject' , this.GUID);
    formData.append('ToEmailAddress' , this.toEmailAddress);
    formData.append('UserName' , localStorage.getItem('username'));
    
    this.global.createLoader();
    this.global.loading.present().then((result) => {
      this.http.post('timesheets/upload_expenses_2/', formData ).subscribe(

        (data) => {
          this.global.loading.dismiss();
          this.presentToast('Image uploaded successfully.');
          if(this.requests.ExpensesDataReceived.observers.length==0){
            this.requests.ExpensesDataReceived.subscribe(
              () => {
                //console.log('Expenses Data Received.......... : ' );
                this.expenses_data = JSON.parse(this.global.dt_expenses[1]); 
                for (var i=0; i< this.expenses_data.length;i++){
                  // debugger
                  var amount = this.expenses_data[i].Amount;
                  this.expenses_data[i].Amount = amount.toFixed(2);
                }
                //this.global.tab2index = this.global.ndays - 1;
                //this.navCtrl.push(TimesheetType3Page, {TAB2ID: this.global.TAB2id[this.global.tab2index]});
              }
            );
          }
          this.requests.httpRequestExpenses_read();
          
          
          this.base64Files=[];
          this.base64FilesNames=[];
          
        },
        error => {
          alert(error);
        }
      );
    }).catch((err) => {

    });

  }

  presentToast(msg: string) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'bottom'
    });

    toast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });

    toast.present();
  }
  
  onFocusValue(event: Event, index: number){
    // debugger
    var ev = event.currentTarget as HTMLInputElement;
    if(ev.value == "0.00" ){
      this.expenses_data[index].Amount = "";
    }
  }
  onChangeValue(event: Event, index: number){
    
    var ev = event.currentTarget as HTMLInputElement;
    if(ev.value == ""){
      this.expenses_data[index].Amount = "0.00";
    } else {
      this.expenses_data[index].Amount =  String(parseFloat(ev.value).toFixed(2));
    }
    
  }
  CreateExpensesXML() {
    this.xmlString = "";
    for (var i = 0; i < this.expenses_data.length; i++){
        //console.log(this.expenses_data[i]);
        if( this.expenses_data[i].Amount == "") this.expenses_data[i].Amount="0.00";
        this.xmlString = this.xmlString + "<row> <ExpenseEntryId>" + this.expenses_data[i].ExpenseEntryId + "</ExpenseEntryId> <Value> " + String(Number(this.expenses_data[i].Amount).toFixed(2))  + " </Value> <Description> " +  this.expenses_data[i].Description + " </Description> <ExpenseTypes> " +  this.expenses_data[i].ExpenseTypeId + " </ExpenseTypes> <Payment> " +  this.expenses_data[i].Payment + " </Payment> </row>";
    }

    this.xmlString = "<tabexpenses2>" + this.xmlString + "</tabexpenses2>";

    //console.log(this.xmlString);
  }

  CalculateExpenses(){
    //Miles    Total Number of Miles
    //MileageRate   
    //MilesAmount = Miles * MileageRate
    //TotalExpenses = Total of Everything that is not miles
    //GrandTotal = MilesAmount + TotalExpenses

    //debugger
    this.global.miles = 0;
    this.global.miles_amount = 0;
    this.global.total_expenses = 0;
    this.global.grand_total = 0;

    for (var i = 0; i < this.expenses_data.length; i++){
      //console.log(this.expenses_data[i]);
      //this.xmlString = this.xmlString + "<row> <ExpenseEntryId>" + this.expenses_data[i].ExpenseEntryId + "</ExpenseEntryId> <Value> " +  this.expenses_data[i].Amount + " </Value> <Description> " +  this.expenses_data[i].Description + " </Description> <ExpenseTypes> " +  this.expenses_data[i].ExpenseTypeId + " </ExpenseTypes> </row>";

      if(this.expenses_data[i].ExpenseTypeId == 9) {
        this.global.miles = this.global.miles + parseFloat(this.expenses_data[i].Amount);
      }
      else {
        this.global.total_expenses = this.global.total_expenses + parseFloat(this.expenses_data[i].Amount);
      }
      
    }

    this.global.miles_amount = this.global.miles * this.global.mileage_rate;
    this.global.grand_total = this.global.miles_amount + this.global.total_expenses;


    //console.log("Total Expenses: " + this.global.total_expenses.toFixed(2));
    //console.log("Total Miles: " + this.global.miles_amount.toFixed(2));
    //console.log("Grand Total: " + this.global.grand_total.toFixed(2));

  }

  //Saving happens when we click any of the buttons
  saveClick() {
    
    this.httprequest_save_expenses("timesheetlist");
  }

  prevClick() {
    this.Grids_get(this.global.TAB2id[this.global.ndays - 1]);
    // this.httprequest_save_expenses("timesheetentry");
    // this.navCtrl.push(TimesheetType3Page);
  }  

  nextClick() {
    // this.httprequest_save_expenses("confirm");
    if(this.global.TimesheetPeriod == 1 ){
      if(this.requests.MonthlyTotalsReceived.observers.length==0){
        this.requests.MonthlyTotalsReceived.subscribe(
          () => {
            // debugger
            //console.log('Monthly Total Data Received.......... : ' );
            this.navCtrl.push(ConfirmType1MonthlyPage);
          }
        );
      }
      this.requests.httpRequest_totalmonthly();
    }
    else {
      if(this.requests.TotalsReceived.observers.length==0){
        this.requests.TotalsReceived.subscribe(
          () => {
            //console.log('Total Data Received.......... : ' );
            this.hidenextprev = true;
            this.navCtrl.push(ConfirmType1Page);
          }
        );
      }
      this.requests.httpRequest_totalgrid1();
    }
  }
  
  httprequest_save_expenses(nextpage: string){

    this.CreateExpensesXML();
    this.CalculateExpenses();

    // debugger
    var p: any = {};
    //p.sp_name = "sp_expenses_write";
    p.timesheetid = this.global.timesheetid;
    p.timesheetentriesid = '0';
    p.miles = String(this.global.miles.toFixed(2));
    p.mileagerate = String(this.global.mileage_rate.toFixed(2));
    p.milesamount = String(this.global.miles_amount.toFixed(2));
    p.totalexpenses = String(this.global.total_expenses.toFixed(2));
    p.grandtotal = String(this.global.grand_total.toFixed(2));
    
    //p.xml = this.xmlString.replace("<","&lt;").replace(">","&gt;").replace("&","&amp;").replace('"',"&quot;").replace("'","&apos;");
    
    p.xml = this.xmlString.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&apos;");

    // console.log(p.xml);
    const params = new HttpParams()
    .set('j',JSON.stringify(p))


    this.http.post('timesheets/expenses_save/',params).subscribe(

      (data: any) => {
        this.hidenextprev = false;
        this.content.resize();
        console.log(this['expenses_data']);
        //debugger
        var saveresult = JSON.parse(data.dt);
        var lastAddedExpenseId = JSON.parse(saveresult)[0].ExpenseEntryId;
        
        if(nextpage == 'timesheetlist'){          
          if(this.requests.ExpensesDataReceived.observers.length==0){
            this.requests.ExpensesDataReceived.subscribe(
              () => {
                //console.log('Expenses Data Received.......... : ' );
                this.expenses_data = JSON.parse(this.global.dt_expenses[1]); 
                for (var i=0; i < this.expenses_data.length;i++){
                  // debugger
                  var amount = this.expenses_data[i].Amount;
                  this.expenses_data[i].Amount = amount.toFixed(2);

                  var pay = this.expenses_data[i].Payment;
                  this.expenses_data[i].Payment = pay? pay: "P";
                  
                  if(!this.expenses_data[i].ExpenseTypeId)  this.expenses_data[i].ExpenseTypeId = 8;

                  this.expenses_taxhandling = this.expenses_data[i].ExpenseTAXHandling;
                  this.expenses_imageupload = this.expenses_data[i].ExpenseImageUpload;
                }

                //this.global.tab2index = this.global.ndays - 1;
                //this.navCtrl.push(TimesheetType3Page, {TAB2ID: this.global.TAB2id[this.global.tab2index]});
              }
            );
          }
          this.requests.httpRequestExpenses_read();
          //this.navCtrl.push(TimesheetlistPage);

        } else if (nextpage == 'timesheetentry') {
          // this.Grids_get(this.global.TAB2id[this.global.ndays - 1]);
         
        } else if (nextpage  == 'confirm'){

        }
      },
      error => {
        alert(error);
      }
    );


  }

  /*showExpensePopup() {
    const prompt = this.alertCtrl.create({
      title: 'Upload',
      message: "",
      inputs: [
        {
          name: 'description',
          placeholder: 'Description'
        },
        {
          name: 'taxapplies',
          placeholder: 'TAX Applies [Y/N]'
        },
        {
          name: 'payment',
          placeholder: 'Payment [P/C]'
        },
        {
          name: 'amount',
          placeholder: 'Amount',
          type: 'number'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Upload Image',
          handler: data => {
            //console.log(data);

            //fill in expenses_data with current expense details
            //debugger
            var indxEmptyExpense = this.expenses_data.findIndex(function(item, i){
              return item.ExpenseEntryId === 0
            });
            console.log(this.expenses_data);
            console.log(indxEmptyExpense);

            this.expenses_data[indxEmptyExpense].Description = data.description;
            this.expenses_data[indxEmptyExpense].TaxApplies = data.taxapplies.toLowerCase()=='y'? 1 : 0;
            this.expenses_data[indxEmptyExpense].Payment = data.payment.toUpperCase();
            this.expenses_data[indxEmptyExpense].Amount = parseFloat(data.amount).toFixed(2);

            console.log(this.expenses_data);
            //this.httprequest_save_expenses("timesheetlist");

            
          }
        }
      ]
    });
    prompt.present();
  }*/
  ionViewDidLoad() {
    console.log('ionViewDidLoad ExpensesPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/expenses/expenses.ts